import { useTranslation } from 'react-i18next';
import { Tabs, TabsList, TabsTrigger } from 'components/ui/tabs';

export function UsageScopeTabs({
  tab,
  onTabChange,
}: {
  tab: 'personal' | 'organization';
  onTabChange: (tab: 'personal' | 'organization') => void;
}) {
  const { t } = useTranslation();

  return (
    <Tabs value={tab} onValueChange={(value) => onTabChange(value as 'personal' | 'organization')}>
      <TabsList className="h-auto rounded-[4px] border border-primary bg-muted/60 px-0.5 py-0.5 shadow-sm">
        <TabsTrigger
          value="personal"
          className="rounded-[2px] px-4 py-1 text-sm font-medium text-muted-foreground transition-all data-[state=active]:bg-primary data-[state=active]:text-primary-foreground data-[state=active]:shadow-sm"
        >
          {t('PERSONAL')}
        </TabsTrigger>
        <TabsTrigger
          value="organization"
          className="rounded-[2px] px-4 py-1 text-sm font-medium text-muted-foreground transition-all data-[state=active]:bg-primary data-[state=active]:text-primary-foreground data-[state=active]:shadow-sm"
        >
          {t('ORGANIZATION')}
        </TabsTrigger>
      </TabsList>
    </Tabs>
  );
}
